import React from 'react';
import { HomeSectionProps } from './HomeSectionProps';

const featuresData = [
    { icon: 'bi-bar-chart-line-fill', title: '실제 경기 통계', text: '실제 KBO 리그 결과를 바탕으로 게임이 이루어집니다.', color: 'bg-danger' },
    { icon: 'bi-people-fill', title: '프라이빗 리그', text: '친구들과 함께 커스텀 리그를 만들어 더욱 재미있는 경쟁을 즐기세요.', color: 'bg-primary' },
    { icon: 'bi-bullseye', title: '선수 분석', text: '상세한 선수 통계와 분석 데이터로 최적의 팀 구성 전략을 세우세요.', color: 'bg-success' },
    // 필요시 다른 기능들 추가
];

const Features: React.FC<HomeSectionProps> = ({ className }) => {
  return (
    <section id="features" className={`py-5 keep-all ${className ?? ''}`}>
      <div className="container py-5">
        <div className="text-center mb-5">
          <span className="badge rounded-pill text-bg-success bg-opacity-75 mb-3">주요 기능</span>
          <h2 className="fw-bold">최고의 판타지 야구 경험을 제공합니다</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>실제 데이터와 직관적인 인터페이스로 몰입감 넘치는 게임을 즐기세요</p>
        </div>
        <div className="row g-4">
          {featuresData.map((feature, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100 text-center border-0" style={{ transition: 'box-shadow 0.3s ease-in-out' }}>
                <div className="card-body p-4">
                  <div className={`d-inline-flex align-items-center justify-content-center ${feature.color} bg-gradient rounded-3 text-white mb-3`} style={{ width: '48px', height: '48px' }}>
                    <i className={`bi ${feature.icon} fs-4`}></i>
                  </div>
                  <h3 className="h5 fw-semibold">{feature.title}</h3>
                  <p className="text-muted small">{feature.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;